import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { 
  createInteractivePageSection, updateWidgetProperty, toggleEditMode, selectPageWidget,
  createPageSegment, selectPageSegment
} from "actions/editor";

import { PAGE } from "constants/widgetTypes";

import _ from "lodash";
import cx from "classnames";
import { Frame } from 'scenejs';

import { Widget } from "components/Editor/widgets/core";
import { EditorContext } from "components/Editor";
import StoryboardContext from "components/Storyboard/context";

import styles from "./segmentRender.module.scss";



const SegmentRender = ({widgets, entityType}) => {
  const dispatch = useDispatch();
  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;
  const editorWidgetViewer = document.getElementsByClassName('editor_widget_viewer')[0];
  const breakpoint = useSelector(state => _.get(state, `${editor}.present.breakpoint`));

  const selectedPageId = useSelector(state => _.get(state, `${editor}.present.selectedPage`));
  const pages = useSelector((state) => {
    const widgets = _.get(state, `${editor}.present.widgets`) || [];
    var pages = widgets.filter((item) => item.type === PAGE);
    pages = _.orderBy(pages, "order", "desc");
    return pages;
  });

  const visiblePages = React.useMemo(
    () =>
      pages.filter((page) =>
        _.get(page, 'properties.desktop.visible', true) !== false
      ),
    [pages]
  );

  const visibleWitdh = breakpoint === 'desktop' ? 1200 : 375;
  const offset =  0;

  const storyboard = React.useContext(StoryboardContext);
  const storyboardType = _.get(storyboard, 'type');
  const tools = useSelector((state) => _.get(state, `${editor}.present.tools`));

  const [activeWidget, setActiveWidget] = useState(null);

  const totalPageHeight = visiblePages.reduce((total, page) => {
    return (
      total +
      parseInt(_.get(page, `properties.${breakpoint}.layout.height`, "0"), 10)
    );
  }, 0);

  const bottomOffset =
    totalPageHeight < 400 ? -(200 + (400 - totalPageHeight)) : -200;

  useEffect(() => {
    const usableHeight = window.innerHeight - 114;
    const thresholds = Array.from({ length: 51 }, (_, i) => i / 50);
    const obs = new IntersectionObserver(() => {
      const selectedPage = document.querySelector(selectedPageId);
      if (selectedPage) {
        const { top, bottom } = selectedPage.getBoundingClientRect();
        const fullyVisible = top >= 114 && bottom <= usableHeight + 114;
        if (fullyVisible) {
          const selectedId = selectedPage.id;
          setActiveWidget(prev => {
            if (prev !== selectedId) {
              const widgetId = selectedId.replace(/^page-/, "");
              dispatch(selectPageSegment(editor, widgetId));
            }
            return selectedId;
          });
          return;
        }
      }
      let maxWidget = null, maxVisible = 0;
      visiblePages.forEach(page => {
        const el = document.getElementById(`page-${page.uid}`);
        if (!el) return;

        const { top, bottom } = el.getBoundingClientRect();
        const visible = Math.max(0, Math.min(bottom, usableHeight + 114) - Math.max(top, 114));
        if (visible > maxVisible) {
          maxVisible = visible;
          maxWidget = el.id;
        }
      });
      if (maxWidget) {
        setActiveWidget(prev => {
          if (prev !== maxWidget) {
            const widgetId = maxWidget.replace(/^page-/, "");
            dispatch(selectPageSegment(editor, widgetId));
          }
          return maxWidget;
        });
      }
    }, { threshold: thresholds });
    const childrenToObserve = visiblePages
      .map(page => document.getElementById(`page-${page.uid}`))
      .filter(Boolean);
    childrenToObserve.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, [widgets, dispatch, visiblePages, selectedPageId, editor]);
  
  return (
    <div style={{ position: "relative", height: "auto", width: "100%" }}>
      {widgets.map((widget) => {
        if (
          widget.type === PAGE &&
          _.get(widget, 'properties.desktop.visible', true) === false
        ) {
          return null;
        }

        return (
          <Widget
            key={widget.uid}
            widgetProps={widget}
            entityType={entityType}
          />
        );
      })}
      { tools && tools.gridlines &&  storyboardType !== 'INTERACTIVE_CONTENT' &&
        <>
          <div className={cx(styles.boundary, styles.top)} style={{
            top: 0
          }} />
          <div className={cx(styles.boundary, styles.bottom)} style={{
            bottom: 0
          }} />

          <div className={cx(styles.boundary, styles.left)} style={{
            left: `calc((100% - ${visibleWitdh}px)/2)`,
            bottom: `${bottomOffset}px`,
          }} />
          <div id='forGuideLineWidth' style={{width: `calc((100% - ${visibleWitdh}px)/2)`, left: 0, position: "absolute" }}></div>
          <div className={cx(styles.boundary, styles.right)} style={{
            right: `calc((100% - ${visibleWitdh}px)/2)`,
            bottom: `${bottomOffset}px`,
          }} />
        </>
    }
    </div>
  );
};

export default SegmentRender;
